import React, { FC } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { ActionButtons } from '@/components/ratingAndReview/actionButtons/ActionButtons';
import { buildOverallItems } from '@/components/ratingAndReview/overallRating/overallRating.service';
import { breakpoints } from '@/shared/theme';
import { IAppRating } from '@/types';
import { BasicInfo } from './basicInfo';
import { Container, StyledOverallRating } from './content.sc';
import { QualityRating } from './qualityRating';

export interface IContentProps {
  ratings: IAppRating;
}

export const Content: FC<IContentProps> = ({ ratings }) => {
  const overallRatingItems = buildOverallItems(ratings);
  const isMobile = useMediaQuery(breakpoints.mobile);
  return (
    <Container data-test-automation-id={'rating-and-review-tab-ratings'}>
      <BasicInfo
        overallRating={ratings.overallRating}
        voteCount={ratings.voteCount}
      />
      <StyledOverallRating
        items={overallRatingItems}
        automationId={'rating-and-review-tab-overall-ratings'}
      />
      <QualityRating ratings={ratings} />
      {isMobile && <ActionButtons />}
    </Container>
  );
};
